// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"82c827aa","682":"94f9ffc8"}[chunkId] + ".chunk.js";
};